/**
 * Nutrition Report Helper Functions
 */

// Calculate BMR using Mifflin-St Jeor Equation
export function calculateBMR(age, weight, height, gender) {
  if (gender === 'Male') {
    return Math.round(10 * weight + 6.25 * height - 5 * age + 5);
  } else {
    return Math.round(10 * weight + 6.25 * height - 5 * age - 161);
  }
}

// Calculate TDEE
export function calculateTDEE(bmr, activityLevel = 'moderate') {
  const multipliers = {
    sedentary: 1.2,
    light: 1.375,
    moderate: 1.55,
    active: 1.725,
    veryActive: 1.9
  };
  return Math.round(bmr * (multipliers[activityLevel] || 1.55));
}

export function getWeeklyBiohackTip() {
  const tips = [
    { icon: '💡', tip: 'Eat protein within 30 minutes of waking to kickstart metabolism and muscle protein synthesis.' },
    { icon: '🌶️', tip: 'Add turmeric to post-workout meals for anti-inflammatory benefits. Mix with black pepper for 2000% better absorption!' },
    { icon: '🍋', tip: 'Drink warm water with lemon first thing in the morning to hydrate and boost metabolism.' },
    { icon: '⏰', tip: 'Time your largest meal 2-3 hours before training for optimal energy availability.' }
  ];
  return tips[Math.floor(Math.random() * tips.length)];
}
